import React, { useState, useEffect, useRef } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import AppstoreIcon from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import GoogleplayIcon from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import { useHistory, getLocale, useDispatch } from 'umi';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getCountryFlag } from '@/pages/home/_config/countries';
import Databarin from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import DatabrainBubbleTip from '@/pages/intelligence/components/TableComponents/components/FirstRow/DatabrainBubbleTip';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import CommonColumns, {
  DetailsCloums,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import CustomTable from '@/pages/intelligence/components/TableComponents/CustomTable';
import { Table, PagingQuery } from 'tea-component';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';

import {
  overlapSteamTalbeHeaderList,
  getOverlapSteamGamesMetricValueOfCvm,
} from '@intelligence/pages/OverlapAnalysis/MobileGames/utils';
import { steamTagsColumn } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';

import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

const { scrollable } = Table.addons;

const platformIcons = {
  ios: AppstoreIcon,
  android: GoogleplayIcon,
} as any;

const SteamGamesTable = (props: any) => {
  const {
    loading,
    records = [],
    tableTotal = 0,
    pageSortAttr,
    onTableSortChage,
    onTablePagingChange,
    dateType,
    genreSource = '',
    entityType,
    fetchParams,
    onClickGame: propsOnClickGame,
    onTagClick,
    segmentKey = '',
    sourceType = 'steam',
    // setOverlapAppIdsLoading,
  } = props;
  // console.log('SteamGamesTable22222222', props);
  const UNIFIED_ID = 'unified_id';
  const APP_ID = 'app_id';
  const dispatch = useDispatch();

  const loadingOrNodata = loading || !records?.length;
  const { formatMessage } = useIntlExtend();
  const locale = getLocale();

  const {
    tablePageIndex,
    tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
  } = pageSortAttr || {};
  const history = useHistory();
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [columns, setColumns] = useState<any>([]);
  const onTagClickRef = useRef(onTagClick);

  onTagClickRef.current = onTagClick;

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const detailCloums = DetailsCloums({
    onClickGame: (cvm: any) => {
      onClickGame(cvm?.[UNIFIED_ID], cvm?.[APP_ID], cvm);
    },
    formatMessage,
  });

  const getMetricCloums = () => {
    if (sourceType === 'otherVendor') {
      return [
        MetricsTableCloums({
          mauToAvgMau: false,
          renderType: RenderType.VALUE_ONLY,
          align: 'right',
          alignRight: true,
          width: 150,
          title: 'dbi_active_users',
          textContent: 'dbi_overlap_other_vendor_active_users_hover',
          key: 'active_users',
          sortMetric: 'active_users',
          currentSortValue,
          currentSortKey: `${currentSortMetric}_0`,
          onSortChage,
          dateType,
          getMetricValueOfCvm: (cvm: any) => ({ value: cvm?.active_users }),
          formatMessage,
          entityType,
          columnsCenterWidth: 150,
          isNewMathValue: true,
        }),
      ];
    }

    const metricCloums: any[] = [];
    // 优先使用 4-segment key，回退到 page_name
    const headerKey = segmentKey || fetchParams.page_name;
    const metricListTemp = overlapSteamTalbeHeaderList[headerKey] || overlapSteamTalbeHeaderList[fetchParams.page_name];
    if (Array.isArray(metricListTemp) && metricListTemp?.length > 0) {
      metricListTemp?.forEach((t: any) => {
        metricCloums.push(
          MetricsTableCloums({
            mauToAvgMau: false,
            renderType: t?.renderType,
            align: t?.align,
            width: t?.width,
            dataSource: t?.dataSource, // source === 'ogdb' ? 'databarin' : source,
            title: t?.text,
            textContent: t?.info,
            key: `${t?.value}`,
            sortMetric: t?.value,
            currentSortValue,
            currentSortKey: `${currentSortMetric}_${currentRatioType}`,
            onSortChage,
            dateType,
            isNoDropdown: t?.isNoDropdown,
            getMetricValueOfCvm: getOverlapSteamGamesMetricValueOfCvm,
            formatMessage,
            entityType,
            columnsCenterWidth: Number(t?.width),
            unitText: t?.unitText,
            isNewMathValue: true,
          }),
        );
      });
    }
    return metricCloums;
  };

  useEffect(() => {
    const cloumss = [
      {
        key: 'gametitle',
        header: (
          <div className="dbi-firstRow-flex">
            <div className="dbi-text-id">#</div>
            <div>
              {formatMessage({
                id: sourceType === 'otherVendor' ? 'dbi_top_gametitle' : 'dbi_top_gametitle_b',
              })}
            </div>
          </div>
        ),
        width: 330,
        fixed: 'left',
        render: (cvm: any) => {
          const platform = Array.isArray(cvm?.platform)
            ? cvm.platform[0]
            : cvm?.platform;
          const platformIcon = platformIcons[platform];
          return (
            <FirstRow
              id={cvm?.insideTable ? <></> : cvm?.rank}
              cvm={{
                img: cvm?.cover,
                gametitle: cvm?.name,
                countryIcon: getCountryFlag(
                  sourceType === 'otherVendor' ? cvm?.publisher_addr : cvm?.markets,
                ),
                text: cvm?.publisher,
                isDatabrain: cvm.b_ogdb_data ? Databarin : '',
                databrainIconTip: <DatabrainBubbleTip />,
                frontIcon: platformIcon,
                imgType: 'pc',
              }}
              rihgtClickToJumpHref={getDetailGamePath(cvm?.[UNIFIED_ID], cvm)}
              onClick={() => {
                onClickGame(cvm?.[UNIFIED_ID], cvm?.[APP_ID], cvm);
              }}
            />
          );
        },
      },
      ...getMetricCloums(),
      CommonColumns.ReleaseTimeColumn({
        locale,
        formatMessage,
        hoverTipsKey: 'dbi_overlapsteam_release_time',
      }),
      // 复用 TopCharts 已有的 steamTagsColumn 配置，通过 MetricsTableCloums 统一渲染 RenderType.TAGS
      MetricsTableCloums({
        mauToAvgMau: false,
        renderType: steamTagsColumn.renderType,
        align: 'left',
        width: steamTagsColumn.width,
        dataSource: steamTagsColumn.dataSource,
        title: steamTagsColumn.text,
        key: steamTagsColumn.metricKey,
        sortMetric: steamTagsColumn.metricKey,
        currentSortValue,
        currentSortKey: `${currentSortMetric}_${currentRatioType}`,
        onSortChage,
        onTagClick: (type: string, tag: string) => onTagClickRef.current?.(type, tag),
        dateType,
        isNoDropdown: steamTagsColumn.isNoDropdown,
        getMetricValueOfCvm: (cvm: any, metricKey: string) => {
          // steam_tag 是顶层字段，直接从 cvm 取值
          const data = cvm?.[metricKey];
          return data;
        },
        formatMessage,
        entityType,
        columnsCenterWidth: steamTagsColumn.width,
        isNewMathValue: true,
      }),
      CommonColumns.GenreColumn({ genreSource }),
      detailCloums,
    ];

    setColumns(cloumss.filter(Boolean));
  }, [JSON.stringify(records), locale, segmentKey, sourceType]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const getDetailGamePath = (gameId: string, cvm: any) => {
    const combinedId = cvm?.combined_id ? cvm.combined_id : '';
    // setOverlapAppIdsLoading && setOverlapAppIdsLoading(true);
    return getDetailGamePathCommon({
      entityType:
        combinedId !== '' && entityType === 'combine' ? 'combine' : 'pc',
      gameId:
        combinedId !== '' && entityType === 'combine' ? combinedId : gameId,
      tab: 'overlap',
      subTab: '',
    });
  };

  const onClickGame = (unifiedId: string, appId: string, cvm: any) => {
    if (propsOnClickGame) {
      return propsOnClickGame?.(cvm);
    }
    dispatch({
      type: `${DBI_TOPCHARTS}/setOverlapAnalysisAppid`,
      payload: appId,
    });
    history.push(getDetailGamePath(unifiedId, cvm));
  };

  return (
    <CardSlotV2>
      {/* 公共类名 */}
      <div id="demographics-topcharts-table">
        <CustomTable
          loading={loading}
          records={records}
          className="dbi-mobileGames-table dbi-table-sticky"
          recordKey={sourceType === 'otherVendor' ? 'combined_id' : APP_ID}
          columns={columns}
          tableTotal={tableTotal}
          pageSize={pageSize}
          pageIndex={pageIndex}
          onPagingChange={(e) => {
            if (onPagingChange instanceof Function) {
              onPagingChange(e);
            }
          }}
          tableAddons={[
            scrollable({
              minWidth: 'auto',
              minHeight: loadingOrNodata ? '158px' : 'auto',
            }),
          ]}
        />
      </div>
    </CardSlotV2>
  );
};

export default SteamGamesTable;
